export const getArraySum = <T extends Record<string, unknown>>(arr: T[], prop = '') =>
  arr.reduce((acc, cur) => {
    const val = Number(cur[prop])
    if (isNaN(val)) {
      throw Error('Cannot calculate the sum as some elements are not numbers!')
    }
    return acc + val
  }, 0)

export const getArraySumForSameCurrency = <T extends Record<string, unknown>>(
  arr: T[],
  prop = '',
  currency = ''
) =>
  arr.reduce((acc, cur) => {
    const val = Number(cur[prop])
    if (isNaN(val)) {
      throw Error('Cannot calculate the sum as some elements are not numbers!')
    }
    return cur.currency === currency ? acc + val : acc
  }, 0)
